function sectionToggle() {
    $(document.body).on('click', '.account-nav .section-active', (e) => {
        const thisTarget = $(e.currentTarget);
        thisTarget.find('.icon-isclosed').toggleClass('icon-isopen');
        $('.account-nav-mobile-wrapper').slideToggle();
    });
}

function selectActiveSection() {
    const page = $('.page').data('action');
    const nameContent = page.split('-');
    let lowNameContent = nameContent[0].toLowerCase();

    if (lowNameContent === 'paymentinstruments') {
        lowNameContent = 'payments';
    }

    if (nameContent[0].toLowerCase() === 'account') {
        lowNameContent = nameContent[1].toLowerCase() === 'editprofile'
            ? 'editprofile'
            : nameContent[0].toLowerCase();
    }

    if (lowNameContent !== '') {
        $(`.${lowNameContent}`).addClass('active');
        const sectionActive = $('.section-active');
        const accountNavArrow = '<span class="pl-2 icon-isclosed" />';
        const staticMainWrapper = $('.static-main-wrapper');
        let sectionActiveText = '';

        if (lowNameContent === 'static' || (lowNameContent !== 'contactus' && staticMainWrapper.length)) {
            const pageQuerystring = $('.page').data('querystring');
            const nameContentStatic = pageQuerystring.split('=');
            const nameContentCid = nameContentStatic[1];
            const activeNavitem = $(`.account-nav .nav-account-item[data-cid="${nameContentCid}"]`);
            activeNavitem.addClass('active');
            sectionActiveText = activeNavitem.text();
        } else if (lowNameContent === 'contactus') {
            const activeNavitem = $(`.account-nav .nav-account-item[data-cid="${lowNameContent}"]`);
            activeNavitem.addClass('active');
            sectionActiveText = activeNavitem.text();
        } else {
            sectionActiveText = $.trim($('.account-nav .nav-account-item.active a').text());
        }

        sectionActive.text(sectionActiveText);
        sectionActive.append(accountNavArrow);
    }
}

module.exports = {
    sectionToggle,
    selectActiveSection,
};
